export const environment = {
  VERSION: require('../../package.json').version,
  versionCheckDelay: 300,
  production: true,
  apiUrl: 'https://api.centigradeonline.co.uk/api/centigrade/v1/',
  dcdUrl: 'https://dcd.myfuturechoice.com/',
  myFJURL: 'https://myfuturejourney.com',
  sentryDsn:
    'https://5cc36411cf1303c99ab298541d7e927b@o4507922527354880.ingest.de.sentry.io/4507922629722192',
  canRegister: true,
  paymentPortal: 'https://buy.myunichoices.com/',
  gtmId: 'GTM-MRHBTNB'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts